// extracted by mini-css-extract-plugin
module.exports = {"container":"SalesMainContainer_container__1lXfj"};